<template>
    <div>
        <b-modal
            :no-close-on-backdrop="true" 
            scrollable 
            centered 
            size="xl"  
            @hide="this.emitEventCancel"
            :id="ModalIdAuditCRUD" 
            :title="this.dialogTitle"  
            style="padding:none!important" 
            ok-only
        >
            <b-row>
                <div class="col-md-12 grid-margin stretch-card">
                    <div class="card activeCard">
						<div class="card-body">
                            <div class="d-flex align-items-start justify-content-between">
                                <h6 class="card-title flex-grow lower-line text-truncate">{{ this.$t('AuditList.Resume') }}</h6>
							</div>
                            <div class="flex-container">
                                <div class="row">
                                    <div class="col-md-4" v-if="!showHistory">
                                        <div class="float-left col text-muted p-item">
                                            <small>{{ this.$t('Shared.UserName') }}</small><br>
                                            <b>{{ this.userName }}</b>
                                        </div>
                                    </div>
                                    <div class="col-md-4">
                                        <div class="float-left col text-muted p-item">
                                            <small>{{ this.$t('AuditList.Entity') }}</small><br>
                                            <b>{{ this.entityName }}</b>
                                        </div>
                                    </div>
                                    <div class="col-md-4">
                                        <div class="float-left col text-muted p-item">
                                            <small>{{ this.$t('AuditList.PrimaryKey') }}</small><br>
                                            <b>{{ this.entityKey }}</b>
                                        </div>
                                    </div>
                                    <div class="col-md-4">
                                        <div class="float-left col text-muted p-item">
                                            <small>{{ this.$t('AuditList.PrimaryKeyValue') }}</small><br>
                                            <b>{{ this.entityKeyValue }}</b>
                                        </div>
                                    </div>
                                    <div class="col-md-4" v-if="this.entityKey2">
                                        <div class="float-left col text-muted p-item">
                                            <small>{{ this.$t('AuditList.PrimaryKey') }} 2</small><br>
                                            <b>{{ this.entityKey2 }}</b>
                                        </div>
                                    </div>
                                    <div class="col-md-4"  v-if="this.entityKey2">
                                        <div class="float-left col text-muted p-item">
                                            <small>{{ this.$t('AuditList.PrimaryKeyValue') }} 2</small><br>
                                            <b>{{ this.entityKeyValue2 }}</b>
                                        </div>
                                    </div>
                                    <div class="col-md-4" v-if="this.entityKey3">
                                        <div class="float-left col text-muted p-item">
                                            <small>{{ this.$t('AuditList.PrimaryKey') }} 3</small><br>
                                            <b>{{ this.entityKey3 }}</b>
                                        </div>
                                    </div>
                                    <div class="col-md-4"  v-if="this.entityKey3">
                                        <div class="float-left col text-muted p-item">
                                            <small>{{ this.$t('AuditList.PrimaryKeyValue') }} 3</small><br>
                                            <b>{{ this.entityKeyValue3 }}</b>
                                        </div>
                                    </div>
                                    <div class="col-md-4" v-if="!showHistory">
                                        <div class="float-left col text-muted p-item">
                                            <small>{{ this.$t('Shared.Date') }}</small><br>
                                            <b>{{ this.date }}</b>
                                        </div>
                                    </div>
                                    <div class="col-md-4" v-if="!showHistory">
                                        <div class="float-left col text-muted p-item">
                                            <small>{{ this.$t('AuditList.Address') }}</small><br>
                                            <b>{{ this.address }}</b>
                                        </div>
                                    </div>
                                    <div class="col-md-4" v-if="this.patientName">
                                        <div class="float-left col text-muted p-item">
                                            <small>{{ this.$t('Shared.PatientName') }}</small><br>
                                            <b>{{ this.patientName }}</b>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </b-row>

            <b-row v-if="!showHistory && !isActionView">
                <div class="col-md-12 grid-margin stretch-card">
                    <div class="card activeCard">
						<div class="card-body">
                            <div class="d-flex align-items-start justify-content-between">
                                <h6 class="card-title flex-grow lower-line text-truncate">{{ title }}</h6>
							</div>
                            <div class="flex-container">
                                <div class="row" v-for="(item, index) in this.items(this.value)" :key="`ENTITY-${index}`">
                                    <div class="col-md-12">
                                        <div class="float-left col text-muted p-item">
                                            <small>{{ entityTitle }}</small><br>
                                            <b>{{ item.entity }}</b>
                                        </div>
                                    </div>
                                    <div class="col-md-4" v-for="(val, i) in item.values" :key="`ITEM-${i}`">
                                        <div class="float-left col text-muted p-item">
                                            <small>{{ val.name }}</small><br>
                                            <template v-if="val.status == 'NEW'">
                                                <b class="added" v-if="!val.isHtmlFormat">{{ val.value }}</b>
                                                <b class="added" v-else v-html="val.value"></b>
                                            </template>
                                            <template v-if="val.status == 'CURRENT'">
                                                <b v-if="!val.isHtmlFormat">{{ val.value }}</b>
                                                <b v-else v-html="val.value"></b>
                                            </template>
                                            <template v-if="val.status == 'UPDATE'">
                                                <ul>
                                                    <li class="added">
                                                        <b class="added" v-if="!val.isHtmlFormat">{{ getValue(val.value, val.isHtmlFormat) }}</b>
                                                        <b class="added" v-else v-html="getValue(val.value, val.isHtmlFormat)"></b>
                                                    </li>
                                                    <li class="deleted">
                                                        <b class="deleted" v-if="!val.isHtmlFormat">{{ getValue(val.old, val.isHtmlFormat) }}</b>
                                                        <b class="deleted" v-else v-html="getValue(val.old, val.isHtmlFormat)"></b>
                                                    </li>
                                                </ul>
                                            </template>
                                            <template v-else>
                                                <b class="deleted" v-if="!val.isHtmlFormat">{{ val.old }}</b>
                                                <b class="deleted" v-else v-html="val.old"></b>
                                            </template>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </b-row>

            <b-row v-if="showHistory">
                <div class="col-md-12 grid-margin stretch-card">
                    <div class="card activeCard">
						<div class="card-body">
                            <div class="d-flex align-items-start justify-content-between">
                                <h6 class="card-title flex-grow lower-line text-truncate">{{ $t('Shared.History') }}</h6>
							</div>
                            <div class="flex-container">
                                <Timeline :value="EntityHistory" align="alternate" class="customized-timeline">
                                    <template #marker="slotProps">
                                        <span >
                                            <i :class="slotProps.item.icon" :style="'color: '+ slotProps.item.color + '; font-size: 1.5rem;'"></i>
                                        </span>
                                    </template>
                                    <template #content="slotProps">
                                        <div class="card mt-4">
                                            <div class="card-header">
                                                <div class="float-left col text-muted">
                                                    <small>{{ $t('Shared.Date') }}:&nbsp;</small>
                                                    <b>{{ slotProps.item.sysDate }}</b>
                                                </div>
                                                <div class="float-left col text-muted">
                                                    <small>{{ $t('Shared.UserName') }}:&nbsp;</small>
                                                    <b>{{ slotProps.item.userName }}</b>
                                                </div>
                                                <div class="float-left col text-muted">
                                                    <small>{{ $t('AuditList.Address') }}:&nbsp;</small>
                                                    <b>{{ slotProps.item.ipAddress }}</b>
                                                </div>
                                                <div class="float-left col text-muted">
                                                    <small>{{  $tc('Shared.ActionsTxt') }}:&nbsp;</small>
                                                    <b>{{ slotProps.item.actionTrans }}</b>
                                                </div>
                                            </div>
                                            <div class="card-body">
                                                <div class="float-left col text-muted mb-2" v-for="(item, index) in items(slotProps.item)" :key="`HIST-${index}`">
                                                    <div class="float-left col text-muted">
                                                        <small><b>{{ $t('AuditList.Entity') }}:</b>&nbsp;</small>
                                                        <b>{{ item.entity }}</b>
                                                    </div>   

                                                    <div class="float-left col text-muted" v-for="(val, i) in item.values" :key="`HITEM-${i}`">
                                                        <small>{{ val.name }}:&nbsp;</small>
                                                        <template v-if="val.status == 'NEW'">
                                                            <b class="added" v-if="!val.isHtmlFormat">{{ val.value }}</b>
                                                            <b class="added" v-else v-html="val.value"></b>
                                                        </template>
                                                        <template v-if="val.status == 'CURRENT'">
                                                            <b v-if="!val.isHtmlFormat">{{ val.value }}</b>
                                                            <b v-else v-html="val.value"></b>
                                                        </template>
                                                        <template v-if="val.status == 'UPDATE'">
                                                            <ul>
                                                                <li class="added">
                                                                    <b class="added" v-if="!val.isHtmlFormat">{{ getValue(val.value, val.isHtmlFormat) }}</b>
                                                                    <b class="added" v-else v-html="getValue(val.value, val.isHtmlFormat)"></b>
                                                                </li>
                                                                <li class="deleted">
                                                                    <b class="deleted" v-if="!val.isHtmlFormat">{{ getValue(val.old, val.isHtmlFormat) }}</b>
                                                                    <b class="deleted" v-else v-html="getValue(val.old, val.isHtmlFormat)"></b>
                                                                </li>
                                                            </ul>
                                                        </template>
                                                        <template v-else>
                                                            <b class="deleted" v-if="!val.isHtmlFormat">{{ val.old }}</b>
                                                            <b class="deleted" v-else v-html="val.old"></b>
                                                        </template>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </template>
                                </Timeline>
                            </div>
                        </div>
                    </div>
                </div>
            </b-row>

            <template #modal-footer>
                <b-button v-if="!isActionView"
                    variant="primary"
                    @click="emitAllProperties"
                >
                    {{ !allProperties ? $t('AuditCRUD.Expand') :  $t('AuditCRUD.Collate') }}
                </b-button>
                <b-button v-if="!isActionView && !byChangeTracker"
                    variant="primary"
                    @click="emitShowHistory"
                >
                    {{ showHistory ? $t('AuditList.HideHistory') :  $t('AuditList.ShowHistory') }}
                </b-button>
                <b-button
                    variant="primary"
                    @click="emitEventCancel"
                >
                    {{ $t('Shared.Close') }}
                </b-button>
            </template>
        </b-modal>
    </div>
</template>

<script>
import AuditService from '@/services/audit.service'
import ShowMessage from '@/components/messages/ShowMessage.js'
import { EventBus } from '@/event-bus.js';
import Utils from '@/common/utils'
import AuditUtils from '@/components/pages/audit/AuditUtils.js'

export default {
    name: 'AuditCRUDDialog',
    mixins: [ShowMessage],

    props: {
        VisibleDialog:Boolean,
        value: Object
    },

    data() {
        return {
            ModalIdAuditCRUD: 'ModalIdAuditCRUD',
            allProperties: false,
            showHistory: false,
            EntityHistory: [],
            loadHistory : false,
        };
    },

    watch: {
        VisibleDialog(newVal) {
            if (newVal) {
                this.allProperties = false;
                this.$bvModal.show(this.ModalIdAuditCRUD);
            }
        }
    },

    computed: {
        dialogTitle() {
            return this.value ? `${this.$t('Shared.AuditTitle')}: ${this.value.moduleTrans??''}` : this.$t('Shared.AuditTitle');
        },

        title() {
            return this.value ? `${this.$tc('Shared.ActionsTxt')}: ${this.value.actionTrans}` : '';
        },

        date() {
            return this.value ? this.value.sysDate : '';
        },

        address() {
            return this.value ? this.value.ipAddress : '';
        },

        entityTitle() {
            return this.$t('AuditList.Entity')
        },

        isItemUpdated() {
            return this.value?.action == 'WAA_UPDATE';
        },

        isItemAdded() {
            return this.value?.action == 'WAA_INSERT';
        },

        isItemDeleted() {
            return this.value?.action == 'WAA_DELETE';
        },

        ClassProp(){
            if (this.value?.action == 'WAA_INSERT') {
                return 'Added';
            }

            return '';
        },

        userName() {
            return this.value?.userName ?? '';
        },

        entityKey() {
            return this.value?.entityKey ?? '';
        },

        entityKey2() {
            return this.value?.entityKey2;
        },

        entityKey3() {
            return this.value?.entityKey3;
        },

        patientName() {
            return this.value?.patientName ?? '';
        },

        entityKeyValue() {
            return this.value?.entityKeyValue ?? '';
        },

        entityKeyValue2() {
            return this.value?.entityKeyValue2 ?? '';
        },

        entityKeyValue3() {
            return this.value?.entityKeyValue3 ?? '';
        },

        entityName() {
            return this.value?.entityName ?? '';
        },

        isActionView() {
            return this.value?.action == 'WAA_VIEW'
        },

        byChangeTracker() {
            return this.value?.byChangeTracker;
        }
    },

    methods: {
        emitEventCancel() {
            this.$bvModal.hide(this.ModalIdAuditCRUD);
            this.allProperties = false;
            this.showHistory = false;
            this.loadHistory = false;
            this.EntityHistory = [];
            this.$emit('close');
        },

        items(item) {
            let data = [];
            if (item && !this.isActionView) {
                try {
                    const obj = JSON.parse(item.payload);
                    if (Array.isArray(obj)) {
                        obj.forEach((element) => {
                            Object.keys(element).forEach((i) => {
                                const entity = element[i];
                                if (Array.isArray(entity)) {
                                    entity.forEach((e) => {
                                        data.push({entity: i, values: AuditUtils.parseEntity(i, e, item.action, this.allProperties)});
                                    });
                                } else {
                                    data.push({entity: i, values: AuditUtils.parseEntity(i, entity, item.action, this.allProperties)});
                                }
                            });
                        });
                    } else {
                        Object.keys(obj).forEach((i) => {
                            const entity = obj[i];
                            if (Array.isArray(entity)) {
                                entity.forEach((e) => {
                                    data.push({entity: i, values: AuditUtils.parseEntity(i, e, item.action, this.allProperties)});
                                });
                            } else {
                                data.push({entity: i, values: AuditUtils.parseEntity(i, entity, item.action, this.allProperties)});
                            }
                        });
                    }
                } 
                catch { 
                    //TODO
                }
            }

            const tableHeader = ['NotesHeaderTable'.toLocaleLowerCase(), 'NotesHeaderGNTable'.toLocaleLowerCase(), 'NotesHeaderVerTable'.toLocaleLowerCase()]
            const headers = data.filter(x => tableHeader.indexOf(x.entity.toLowerCase()) != -1);
            const items  = data.filter(x => tableHeader.indexOf(x.entity.toLowerCase()) == -1)
                                .sort((a, b) => {
                                    const x = a.entity.toLowerCase();
                                    const y = b.entity.toLowerCase();
                                    return x < y ? -1 : x > y ? 1 : 0;
                                });

            return headers.concat(items);
        },

        emitAllProperties() {
            this.allProperties = !this.allProperties;
        },

        emitShowHistory() {
            this.showHistory = !this.showHistory;
            if (this.showHistory && !this.loadHistory) {
                EventBus.$emit('ShowWeel', true); 
                AuditService.getHistory(this.value.recId)
                    .then((response) => {
                        if (response.data && response.data.length > 0) {
                            this.EntityHistory = response.data;
                            this.EntityHistory.forEach((element) => {  
                                let { sysDate  } = element 
                                if (sysDate) element.sysDate = `${Utils.formatterDateTimeToString(sysDate)}`;
                                element.actionTrans = AuditUtils.translateAction(element.action);
                                element.moduleTrans = AuditUtils.translateModule(element.module);   
                                element.icon = element.recId == this.value.recId ? "mdi mdi-checkbox-marked-circle" :
                                    (element.action == 'WAA_INSERT' ? 'mdi mdi-plus-circle' : (element.action == 'WAA_UPDATE' ? 'mdi mdi-checkbox-blank-circle' : 'mdi mdi-minus-circle'));

                                element.color = element.action == 'WAA_INSERT' ? 'green' : (element.action == 'WAA_UPDATE' ? 'black' : 'red');
                            });
                        }
                        EventBus.$emit('ShowWeel', false); 
                    })
                    .catch((error) => {
                        EventBus.$emit('ShowWeel', false); 
                        this.showResponseErrorMessage(error);
                    })
            }
        },

        getValue(str, isHtmlContent) {
            if (Utils.isNullOrEmptyString(str)) {
                if (isHtmlContent) {
                    return `<p>${this.$t('AuditList.Empty')}</p>`;
                } else {
                    return `${this.$t('AuditList.Empty')}`;
                }
            }

            return str;
        }
    }
}
</script>

<style scoped>
.deleted {
    color: red;
}
.added {
    color: green;
}
.marker {
    border-radius: 9999px;
    width: 1.5rem;
    height: 1.5rem;
    align-items: center;
    justify-content: center;
    border-color: black;
    display: flex;
    z-index: 10;
}
</style>